import { Box, Stack, Typography } from '@mui/material';
import { formatter } from '@repo/utils';
import { BRAND_GRADIENTS, BRAND_TONE, CENTERED_ICON, COLORS, RADIUS, SHADOWS } from '../../constants';
import { MaterialIcon } from '../materialIcon';

// Same content as customer-mobile's QR MerchantHeader (centered brand caption, merchant and amount, cents rendered
// smaller), on a brand-washed card with a store badge and the operation number as a pill
export const OrderCard = ({
  merchantName,
  merchantOrderId,
  price,
  isLoan,
}: {
  merchantName: string;
  merchantOrderId: string;
  price: string;
  isLoan?: boolean;
}) => {
  const [integer, cents] = formatter(price, 'currency').split(',');
  const brand = COLORS.text.brand;

  return (
    <Stack
      sx={{
        alignItems: 'center',
        gap: 1,
        width: '100%',
        px: 3,
        pt: 3,
        pb: 2.5,
        textAlign: 'center',
        borderRadius: `${RADIUS.xl}px`,
        background: BRAND_GRADIENTS.cardWash(),
      }}
    >
      <Box
        sx={{
          ...CENTERED_ICON,
          width: 56,
          height: 56,
          mb: 1,
          borderRadius: `${RADIUS.full}px`,
          backgroundColor: COLORS.surface.raised,
          boxShadow: SHADOWS.card,
        }}
      >
        <MaterialIcon icon="storefront" size={28} sx={{ ...CENTERED_ICON, color: COLORS.text.brand }} />
      </Box>
      <Typography component="p" variant="body1" sx={{ color: brand }}>
        {isLoan ? 'Monto de tu préstamo' : 'Total de tu compra'}
        {merchantName ? ' en' : ''}
      </Typography>
      {merchantName && (
        <Typography
          component="p"
          sx={{
            typography: 'h2',
            letterSpacing: '0.01em',
            fontSize: 20,
            lineHeight: '24px',
            fontWeight: 700,
            color: brand,
          }}
        >
          {merchantName}
        </Typography>
      )}
      <Stack direction="row" sx={{ alignItems: 'flex-start', mt: 1 }}>
        <Typography
          component="span"
          sx={{
            typography: 'h2',
            letterSpacing: '0.01em',
            fontSize: 40,
            lineHeight: '48px',
            fontWeight: 700,
            color: brand,
          }}
        >
          {integer}
        </Typography>
        {cents && (
          <Typography
            component="span"
            sx={{
              typography: 'h2',
              letterSpacing: '0.01em',
              fontSize: 20,
              lineHeight: '28px',
              fontWeight: 700,
              color: brand,
              // Faded blue still clears 4.5:1; faded violet wouldn't, so B2C cents stay solid
              opacity: BRAND_TONE === 'b2b' ? 0.75 : 1,
            }}
          >
            ,{cents}
          </Typography>
        )}
      </Stack>
      <Box
        component="p"
        sx={{
          m: 0,
          mt: 1.5,
          px: 1.5,
          py: 0.5,
          borderRadius: `${RADIUS.full}px`,
          backgroundColor: COLORS.surface.raised,
          color: COLORS.text.light,
          fontSize: 13,
          lineHeight: '18px',
          fontWeight: 500,
        }}
      >
        Número de operación: {merchantOrderId}
      </Box>
    </Stack>
  );
};
